export const GC_TIME_10_MIN = 10 * 60 * 1000;

export const STALE_TIME_10_MIN = 10 * 60 * 1000;

export const STALE_TIME_30_MIN = 30 * 60 * 1000;
